import React from "react";
import Pill from "../../ui/atoms/Pill";

interface PermissionPillProps {
  value: string;
}

const PermissionPill: React.FC<PermissionPillProps> = ({ value }) => {
  return <Pill className="permission-pill">{value}</Pill>;
};

export default PermissionPill;
